import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AgentResponse } from '../models/agent.model';

@Injectable({
  providedIn: 'root',
})
export class HstService {
  private readonly http = inject(HttpClient);

  getDealerList(): Observable<AgentResponse> {
    const url = 'hst/agent-list';
    return this.http.get<AgentResponse>(url);
  }

  getUserAgentList(userId: string): Observable<AgentResponse> {
    const url = 'hst/user-agent-list';
    return this.http.post<AgentResponse>(url, { userId: userId });
  }
}
